module.exports = __webpack_public_path__ + "assets/01.ee77bfc9.pdf";